import { HAS_WINDOW_SUPPORT, WINDOW } from './env';

/* istanbul ignore next */
const Element = HAS_WINDOW_SUPPORT ? WINDOW.Element : class Element extends Object {};

/* istanbul ignore next */
const HTMLElement = HAS_WINDOW_SUPPORT ? WINDOW.HTMLElement : class HTMLElement extends Element {};

/* istanbul ignore next */
const SVGElement = HAS_WINDOW_SUPPORT ? WINDOW.SVGElement : class SVGElement extends Element {};

/* istanbul ignore next */
const File = HAS_WINDOW_SUPPORT ? WINDOW.File : class File extends Object {};

export { Element, File, HTMLElement, SVGElement };
